import {
  RETRIEVE_DAY_OFF_LIST,
  RETRIEVE_DAY_OFF_DETAIL,
  RETRIEVE_DAY_OFF_DATE_LIST,
  CREATE_DAY_OFF,
  UPDATE_DAY_OFF,
  DELETE_DAY_OFF
} from '@/api'

export default {
  retrieveDayOffList({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.day_off_list.length) {
        commit('retrieveDayOffList', {dayOffList: response.data.data.day_off_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_DAY_OFF_LIST({}, successCallback, errorCallback)
  },

  retrieveDayOffDetail({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    let id = payload.id

    RETRIEVE_DAY_OFF_DETAIL({ id }, successCallback, errorCallback)
  },

  retrieveDayOffDateList({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_DAY_OFF_DATE_LIST({}, successCallback, errorCallback)
  },

  createDayOff({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.day_off_info) {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    }

    let title = payload.title
    let type = payload.type
    let data = payload.data

    CREATE_DAY_OFF({ title, type, data }, successCallback, errorCallback)
  },

  updateDayOff({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.day_off_info) {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    }

    let title = payload.title
    let type = payload.type
    let data = payload.data
    let id = payload.id

    UPDATE_DAY_OFF({ id, title, type, data }, successCallback, errorCallback)
  },

  deleteDayOff({commit}, payload) {
    let index = payload.index
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      commit('deleteDayOff', { index })

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    DELETE_DAY_OFF({id: payload.id}, successCallback, errorCallback)
  }
};
